import { useMemo } from 'react';

import {
  atom,
  SetterOrUpdater,
  selector,
  useRecoilState,
  useRecoilValue,
  useSetRecoilState,
} from 'recoil';

import { CoreTimeseriesEntryCollection, CoreTimeseriesEntry } from './types';

export const coreTimeseriesAtom = atom<CoreTimeseriesEntryCollection>({
  key: 'coreTimeseriesAtom',
  default: [],
});

export const coreTimeseriesValuesMap = selector({
  key: 'coreTimeseriesValuesMap',
  get: ({ get }) => {
    const coreTimeseries = get(coreTimeseriesAtom);
    return coreTimeseries.reduce<Record<string, CoreTimeseriesEntry>>(
      (acc, entry) => {
        acc[entry.id] = entry;
        return acc;
      },
      {}
    );
  },
});

export const useCoreTimeSeriesAtom = (): [
  CoreTimeseriesEntryCollection,
  SetterOrUpdater<CoreTimeseriesEntryCollection>,
] => useRecoilState(coreTimeseriesAtom);

export const useCoreTimeSeriesValue = (): CoreTimeseriesEntryCollection =>
  useRecoilValue(coreTimeseriesAtom);

export const useCoreTimeseriesItemValue = (id: string): CoreTimeseriesEntry => {
  const coreTimeseriesValueMap = useRecoilValue(coreTimeseriesValuesMap);
  return useMemo(
    () => coreTimeseriesValueMap[id],
    [coreTimeseriesValueMap, id]
  );
};

export const useSetCoreTimeSeries =
  (): SetterOrUpdater<CoreTimeseriesEntryCollection> =>
    useSetRecoilState(coreTimeseriesAtom);
